import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-number-of-attempts-dialog',
    templateUrl: './number-of-attempts-dialog.component.html',
    styleUrls: ['./number-of-attempts-dialog.component.scss'],
})
export class NumberOfAttemptsDialogComponent implements OnInit {
    @Input()
    set value(value: number) {
        this.valueCtrl.setValue(value);
    }

    @Input()
    isUnlimited: boolean;

    valueCtrl = new FormControl(null, [Validators.required]);
    isUnlimitedChanged: boolean = false;

    @Output()
    save = new EventEmitter<{ value: string; isUnlimited: boolean }>();

    constructor(public dialogRef: MatDialogRef<NumberOfAttemptsDialogComponent>, private _cd: ChangeDetectorRef) {}

    ngOnInit(): void {
        if (this.isUnlimited) {
            this.valueCtrl.disable();
        }
    }

    updateToggleButton(): void {
        this.isUnlimitedChanged = !this.isUnlimitedChanged;

        if (this.isUnlimited) {
            this.valueCtrl.disable();
        } else {
            this.valueCtrl.enable();
        }
    }
}
